import { render } from "./ClusterItemProxy.vue?vue&type=template&id=838f43d0&ts=true"
import script from "./ClusterItemProxy.vue?vue&type=script&lang=ts"
export * from "./ClusterItemProxy.vue?vue&type=script&lang=ts"

import "./ClusterItemProxy.vue?vue&type=style&index=0&id=838f43d0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__